<template>
    <div class="progress progress-striped active">
        <div v-for="bar in bars"
             :class="['progress-bar', 'progress-bar-' + bar.color]"
             :style="{width: bar.percentage+'%'}">
            <span class="sr-only"> {{ bar.percentage }}% </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['bars']
    };
</script>